module.exports = __webpack_public_path__ + "img/xindong.519671f1.png";